import { render } from "./EmptyBagState.vue?vue&type=template&id=f2ade880&scoped=true"
import script from "./EmptyBagState.vue?vue&type=script&lang=js"
export * from "./EmptyBagState.vue?vue&type=script&lang=js"

import "./EmptyBagState.vue?vue&type=style&index=0&id=f2ade880&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ade880"]])

export default __exports__